import React from "react";

// Pure — reproduces getACWRTooltip's JSX from structured rows.
export const AcwrTooltip = ({ rows, showTrailingBreak = false }) => {
    if (!rows) return null;
    return (
        <>
            <span style={{ fontWeight: "bold" }}> ACWR: </span> <br />
            {rows.map((row, i) => (
                <span key={`${row.name}_ACWR${i}`}>
                    {row.name} : <span style={{ color: row.color }}>{row.value}</span> <br />
                </span>
            ))}
            {showTrailingBreak && <br />}
        </>
    );
};
